import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/szymon-mini-one/worktrees/landing-batch254-20261104/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/Users/szymon-mini-one/worktrees/landing-batch254-20261104/layouts/login.vue").then(m => m.default || m))
}